<template>
    <AbstractZoneSelector
            v-bind:zoneId="zoneId"
            v-on:update:zoneId="$emit('update:zoneId', $event)"
            v-bind:countryCode="countryCode"
            v-bind:addressApi="$api.address"
            v-bind:placeholder="placeholder"
            v-bind:hideLabel="hideLabel"
            v-bind:lodashDebounce="lodashDebounce"
            :custom-input-class="customInputClass"
    >
    </AbstractZoneSelector>
</template>

<script>
    import AbstractZoneSelector from '../../../../../vue-widgets/src/Zone/AbstractZoneSelector';
    import lodashDebounce from 'lodash/debounce';

    export default {
        props: {
            placeholder: String,
            hideLabel: Boolean,
            zoneId: Number,
            countryCode: String,
			customInputClass:String,
        },
        computed: {
            lodashDebounce() {
                return lodashDebounce;
            }
        },
        components: {AbstractZoneSelector},
    };
</script>
